import React from "react";
import { ShieldCheck, Wrench, Truck, Headphones } from "lucide-react";
import { PILLARS } from "@/lib/site";

const ICONS = { ShieldCheck, Wrench, Truck, Headphones };

export default function WhyChooseUs() {
  return (
    <section
      id="perche-noi"
      data-testid="why-choose-us-section"
      className="relative bg-[#0a0a0a] py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 grid-pattern opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-px bg-[#E63946]" />
              <span className="text-xs uppercase tracking-[0.3em] font-mono text-[#E63946]">
                / 02 — Perché Noi
              </span>
            </div>
            <h2 className="font-heading font-black leading-[0.9] tracking-tighter text-5xl md:text-6xl">
              L'Eccellenza
              <br />
              <span className="text-[#E63946]">MotorieRicambi</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-zinc-400 text-lg leading-relaxed">
              Standard rigorosi, processi certificati e una passione meccanica
              tramandata da generazioni. Solo il meglio del mercato dei
              ricambi automobilistici — niente scorciatoie, solo precisione.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {PILLARS.map((p, idx) => {
            const Icon = ICONS[p.icon];
            return (
              <div
                key={p.title}
                data-testid={`pillar-${idx}`}
                className="group relative bg-[#0e0e0e] hover:bg-[#141414] p-8 lg:p-10 lift overflow-hidden"
              >
                <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#E63946]/0 to-transparent group-hover:via-[#E63946] transition-all duration-500" />
                <div className="absolute top-6 right-6 font-mono text-xs text-zinc-600">
                  0{idx + 1}
                </div>

                <div className="w-14 h-14 flex items-center justify-center border border-white/10 group-hover:border-[#E63946] group-hover:bg-[#E63946]/10 transition-all duration-300 mb-8">
                  <Icon
                    size={24}
                    className="text-white group-hover:text-[#E63946] transition-colors"
                    strokeWidth={1.4}
                  />
                </div>

                <h3 className="font-heading font-bold text-xl mb-3 tracking-tight">
                  {p.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
